import "../src/Game-Keybord/scss/main.css";
import "../src/Game-Keybord/js/index";

function App() {
  return <div className="App"></div>;
}

export default App;
